import React from 'react';

import { isMobile } from 'app/packages/lib/mobile';
import { getMobileOperationSystem, MobileOS } from 'app/packages/lib/mobile/getOperationSystem';

type UserAgentContextValue = {
  userAgent: string;
  mobileOperationSystem: MobileOS;
  isMobile: boolean;
};

const UserAgentContext = React.createContext<UserAgentContextValue>({
  userAgent: '',
  mobileOperationSystem: 'unknown',
  isMobile: false,
});

export const useUserAgent = () => {
  return React.useContext(UserAgentContext);
};

export const UserAgentProvider: React.FC<React.PropsWithChildren<{ value: string }>> = ({
  value,
  children,
}) => {
  return (
    <UserAgentContext.Provider value={{
      userAgent: value,
      mobileOperationSystem: getMobileOperationSystem(value),
      isMobile: isMobile(value),
    }}>
      {children}
    </UserAgentContext.Provider>
  );
};
